import { render, staticRenderFns } from "./two_images_horizontal.vue?vue&type=template&id=1877d502&"
import script from "./two_images_horizontal.vue?vue&type=script&lang=js&"
export * from "./two_images_horizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports